<template>
  <div class="minibarchart-page">
    <div :id="minibarid" class="minibarchart-container"></div>
  </div>
</template>

<script>
export default {
  props: {
    minibarid: String,
    chartdata: {
      type: Array
    }
  },
  data(){
    return{

    }
  },
  created() {
    this.$nextTick(() => {
      this.initMiniBarChart(this.chartdata)
    });
  },
  watch: {
    chartdata() {
      this.$nextTick(() => {
        this.initMiniBarChart(this.chartdata)
      });
    },
  },

  methods: {
    initMiniBarChart: function(chartdata){
      let that = this
      if(document.getElementById(this.minibarid) === null) return
      let myLineChart = this.$echarts.init(document.getElementById(this.minibarid))
      let option = {
        grid: {
          top: '10',
          left: '65',
          right: '20',
          bottom: '0'
        },
        xAxis: {
          show: false,
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: '#333333',
            fontSize: 12
          },
          data: [that.$t('kpi.s24'), that.$t('kpi.s23'), that.$t('kpi.s22'), that.$t('kpi.s21')],
          axisLine: {
            show: false
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: '10',
            data: chartdata,
            label: {
                show: true,
                position: 'right',
                valueAnimation: true
            }
          },
        ]
      }      
      myLineChart.clear()
      myLineChart.setOption(option)
      $(window).resize(function () {
        myLineChart.resize()
      })
    },
  }
}
</script>